module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#personalise",
      toString: function () {
        return this.url;
      }
    }